export const PlusIconGuide = () => {
    return (
        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.5 7.5V11C6.5 11.2761 6.27614 11.5 6 11.5C5.72386 11.5 5.5 11.2761 5.5 11V7.5H6.5ZM11 5.5C11.2761 5.5 11.5 5.72386 11.5 6C11.5 6.27614 11.2761 6.5 11 6.5H7.5V5.5H11ZM1 5.5H4.5V6.5H1C0.723858 6.5 0.5 6.27614 0.5 6C0.5 5.72386 0.723858 5.5 1 5.5ZM6.5 5.5V6.5H5.5V5.5H6.5ZM6 0.5C6.27614 0.5 6.5 0.723858 6.5 1V4.5H5.5V1C5.5 0.723858 5.72386 0.5 6 0.5Z" fill="#8796AB" stroke="#8796AB" />
        </svg>
    )
}